/*
  Pop-up de newsletter con el codigo de bienvenida.

  Va en un asset y no en la seccion a proposito: el <script> que viaje dentro de
  un bloque repintado por el DOM no se ejecuta, y aqui ademas el custom element
  tiene que estar definido antes de que el navegador lo encuentre.

  QUE HACE. A los N segundos abre el dialogo. El formulario es el nativo de
  Shopify y se envia a pelo: NO por AJAX. Se intento con fetch y la tienda
  responde 403 "Verifying your connection", porque tiene la proteccion
  anti-bots activada y el token que la pasa lo inyecta Shopify en los
  formularios que genera {% form 'customer' %}.

  Asi que la pagina recarga, Shopify vuelve con ?customer_posted=true, el
  marcado ya sale con el codigo visible y aqui solo se abre el dialogo y se
  limpia el parametro de la URL para que no reaparezca al recargar.

  CUANDO NO SALE:
    - Si ya se suscribio desde este navegador. Nunca mas.
    - Si lo cerro, durante los dias que diga el ajuste.
    - En el carrito y en el pago: ahi la clienta ya esta comprando y lo unico
      que puede hacer un pop-up es estorbar.
    - Si el navegador no deja escribir en localStorage, se muestra igual: mejor
      repetirlo alguna vez que no ensenarlo nunca.
*/
(function () {
  if (window.avPopup) return;
  window.avPopup = true;

  var VISTO = 'av-popup-cerrado';
  var SUSCRITO = 'av-popup-suscrito';
  var SCROLL = 'av-popup-scroll';

  function leerSesion(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function escribirSesion(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function borrarSesion(k) { try { sessionStorage.removeItem(k); } catch (e) {} }

  // Donde estaba mirando antes de enviar. Se engancha a CUALQUIER formulario
  // que vaya a /contact -el del pop-up y el del pie-, en captura y a nivel de
  // documento, por dos razones:
  //
  //   1. El del PIE no pasaba por aqui, y un alta desde ahi devolvia la pagina
  //      sin marca de scroll que reponer. Shopify pone posted_successfully? a
  //      true en TODOS los {% form 'customer' %} de la pagina, asi que el
  //      pop-up se abre igual con el codigo: el camino es el mismo, la marca no.
  //   2. El listener que habia vivia al final de connectedCallback, detras de
  //      los return de "ya suscrito", "cerrado hace poco" y "estoy en el
  //      carrito". Quien cerraba el pop-up y se daba de alta en el pie no
  //      guardaba nada, porque ese codigo no llegaba a ejecutarse.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    if ((f.getAttribute('action') || '').indexOf('/contact') === -1) return;
    escribirSesion(SCROLL, String(Math.round(window.scrollY)));
  }, true);

  // Enfocar sin que el navegador desplace la pagina hasta el elemento.
  function enfocar(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function leer(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function escribir(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  customElements.get('av-popup') || customElements.define('av-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.arrancado) return;
      this.arrancado = true;

      this.caja = this.querySelector('[data-av-caja]');
      this.form = this.querySelector('form');
      this.exito = this.querySelector('[data-av-exito]');
      this.campo = this.querySelector('input[type="email"]');
      this.boton = this.querySelector('[data-av-enviar]');
      if (!this.caja || !this.form) return;

      // Si el bloque del codigo esta en el marcado es que Shopify acaba de dar
      // el alta: lo pinta el servidor con form.posted_successfully?, que es la
      // unica senal fiable. Se abre pase lo que pase con el resto de
      // condiciones.
      if (this.exito) {
        escribir(SUSCRITO, '1');
        this.devolverScroll();
        try {
          // Se limpia el parametro, o al recargar volveria a abrirse, Y TAMBIEN
          // EL ANCLA: el action que genera Shopify es /contact#contact_form, y
          // ese id es el del formulario del pop-up, que vive al final del
          // documento porque la seccion cuelga del grupo del pie. Por eso al
          // volver la pagina aparecia abajo del todo, junto al formulario de
          // newsletter del pie.
          var u = new URL(location.href);
          u.searchParams.delete('customer_posted');
          history.replaceState({}, '', u.pathname + u.search);
        } catch (e) {}
        this.engancharCierre();
        this.abrir();
        var c = this.querySelector('[data-av-codigo]');
        if (c) c.focus();
        return;
      }

      // En el carrito y en el pago no se abre nunca.
      if (/^\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return;
      if (leer(SUSCRITO)) return;
      var cerrado = parseInt(leer(VISTO) || '0', 10);
      var dias = parseInt(this.dataset.dias || '7', 10);
      if (cerrado && Date.now() - cerrado < dias * 86400000) return;

      var segundos = parseInt(this.dataset.segundos || '15', 10);
      this.reloj = setTimeout(this.abrir.bind(this), segundos * 1000);

      this.teclado = this.teclado.bind(this);
      this.engancharCierre();

      // El envio es nativo: solo se da senal de que algo esta pasando, porque
      // la pagina va a recargar y hay un momento muerto.
      this.form.addEventListener('submit', function () {
        if (!this.form.checkValidity()) return;
        // La marca de scroll la guarda el listener de documento, arriba.
        this.boton.disabled = true;
        this.boton.textContent = this.boton.dataset.enviando || 'Enviando…';
      }.bind(this));

    }

    devolverScroll() {
      var bruto = leerSesion(SCROLL);
      borrarSesion(SCROLL);
      if (bruto === null) return;
      var y = parseInt(bruto, 10);
      if (isNaN(y) || y < 0) return;

      // EL PROBLEMA, QUE ES UNA CARRERA. El navegador salta al ancla del action
      // -/contact#contact_form en el pop-up, /contact#ContactFooter en el pie-
      // cuando dispara el load, y eso depende de lo que tarden las imagenes de
      // la ficha, que son cientos de KB. Antes aqui habia reposiciones a ciegas
      // en 0, dos rAF, 250 ms, 600 ms y load; si el salto llegaba mas tarde que
      // la ultima, la pagina se iba al pie y ahi se quedaba. Medido el
      // 26/10/2026: el ancla sola lleva la ficha de Sacalaca a 4.902 px.
      //
      // Asi que no se adivina el momento: se vigila la posicion y se corrige
      // cualquier desvio hasta que el usuario toca algo. Su primer gesto manda
      // y suelta la vigilancia, que ademas se suelta sola a los 3 s.
      try { history.scrollRestoration = 'manual'; } catch (e) {}
      var gestos = ['wheel', 'touchstart', 'keydown', 'mousedown'];
      var vivo = true;
      var poner = function () {
        if (vivo && Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
      };
      var soltar = function () {
        if (!vivo) return;
        vivo = false;
        clearInterval(vigilante);
        gestos.forEach(function (ev) { window.removeEventListener(ev, soltar, true); });
      };
      poner();
      var vigilante = setInterval(poner, 50);
      gestos.forEach(function (ev) { window.addEventListener(ev, soltar, true); });
      window.addEventListener('load', poner, { once: true });
      setTimeout(soltar, 3000);
    }

    engancharCierre() {
      if (this.enganchado) return;
      this.enganchado = true;
      this.querySelectorAll('[data-av-cerrar]').forEach(function (b) {
        b.addEventListener('click', this.cerrar.bind(this));
      }, this);
      this.addEventListener('click', function (e) {
        if (e.target === this) this.cerrar();
      }.bind(this));
      var copiar = this.querySelector('[data-av-copiar]');
      if (copiar) copiar.addEventListener('click', this.copiar.bind(this));
    }

    abrir() {
      this.antes = document.activeElement;
      // Donde estaba la pagina al abrir, para dejarla igual al cerrar. Bloquear
      // el scroll con overflow:hidden quita la barra, y eso reflowa el texto y
      // cambia el alto del documento: medido, 81 px en una ficha, que al cerrar
      // movian la pagina 19 px. Poco, pero es un salto y se nota.
      this.scrollAlAbrir = Math.round(window.scrollY);
      this.hidden = false;
      this.setAttribute('abierto', '');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.teclado);
      var exito = this.exito && !this.exito.hidden;
      var f = exito ? this.querySelector('[data-av-codigo]')
                    : (this.campo || this.querySelector('[data-av-cerrar]'));
      // preventScroll: enfocar desplaza hasta el elemento, y la caja del dialogo
      // lleva overflow-y:auto, asi que sin esto el foco puede moverla.
      if (f) enfocar(f);
    }

    cerrar() {
      clearTimeout(this.reloj);
      this.hidden = true;
      this.removeAttribute('abierto');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.teclado);
      // Si ya se suscribio no se marca como "cerrado": manda la otra marca.
      if (!leer(SUSCRITO)) escribir(VISTO, String(Date.now()));
      // El foco vuelve a donde estaba, pero SIN arrastrar la pagina: ese
      // elemento puede estar fuera de la vista -y tras un alta puede ser el
      // formulario del pie, que esta al final del documento-.
      if (this.antes) enfocar(this.antes);
      // Y la pagina se queda exactamente donde estaba al abrir.
      if (typeof this.scrollAlAbrir === 'number' &&
          Math.abs(window.scrollY - this.scrollAlAbrir) > 2) {
        window.scrollTo(0, this.scrollAlAbrir);
      }
    }

    teclado(e) {
      if (e.key === 'Escape') { this.cerrar(); return; }
      if (e.key !== 'Tab') return;
      // El foco no debe escaparse del dialogo mientras esta abierto.
      var f = this.querySelectorAll('button, input, a[href]');
      if (!f.length) return;
      var primero = f[0], ultimo = f[f.length - 1];
      if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
    }

    copiar() {
      var c = this.querySelector('[data-av-codigo]');
      var b = this.querySelector('[data-av-copiar]');
      if (!c || !b) return;
      var texto = (c.textContent || '').trim();
      var hecho = function () {
        var antes = b.textContent;
        b.textContent = b.dataset.copiado || 'Copiado';
        setTimeout(function () { b.textContent = antes; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texto).then(hecho, function () {});
      } else {
        // Sin API de portapapeles -como en http o en navegadores viejos- al
        // menos se deja el codigo seleccionado para copiarlo a mano.
        try {
          var r = document.createRange(); r.selectNodeContents(c);
          var s = getSelection(); s.removeAllRanges(); s.addRange(r); hecho();
        } catch (e) {}
      }
    }
  });
})();
